<script>
    import { fade } from 'svelte/transition'
    import Modal    from '../../shared/SemanticModal.svelte'

    export let key
    export let onRectify

    let working = false
    let error   = false
    let value   = null
    let ack     = false

    $: allowed = isAllowed(value, ack)
    
    function isAllowed(value, ack) {
        return ack && value && value.trim() !== ''
    }

    function cancel() {
        ack   = false
        key   = false
        value = null
    }

    function rectify() {
        working = true
        onRectify(key, value)
            .then(done => {
                working = false
                cancel()
            })
            .catch(e => {
                error = e
                working = false
                setTimeout(() => error = null, 3000)
            })
    }
    
</script>

<Modal active={key}>
    <div class="ui tiny modal visible active">
        <div class="header">
            Retificação da Chave do Pedido
        </div>
        <div class="content">
            <h4>{key.field.name || key.field.definition}</h4>
            <div class="settings">
                <div class="ui input">
                    <input type="text" bind:value={value} placeholder={key.value}>
                </div>
                <div class="ui toggle checkbox">
                    <input type="checkbox" bind:checked={ack}>
                    <label>reinciar execução do pedido para o <b>{key.place.name}</b></label>
                </div>
            </div>
        </div>
        <div class="actions">
            {#if error}
                <div transition:fade class="ui red label">Erro</div>
            {/if}
            <button class="ui black button" 
                    class:disabled={working || error} 
                    on:click={cancel}>
                Cancelar
            </button>
            <button class="ui green right labeled icon button"
                    class:disabled={!allowed || working || error}
                    class:loading={working}
                    on:click={rectify}>
                Retificar<i class="check icon"/>
            </button>
        </div>        
    </div>
</Modal>

<style>
    .settings {
        display: flex;
        flex-direction: column;
    }

    .settings > div {
        margin: 1em 0;
    }
</style>
